module.exports = __webpack_public_path__ + "static/HoneyScript-SemiBold-edbb6def70f5c4f50478e28ee63478ed.ttf";